<template>
  <div class="xianshang-xingwei-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="mouth-and-type single-line">
        <div class="chart-title"></div>
        <div class="chart-content">
          <ol>
            <li
              :class="{ current: app_month == item }"
              :key="index"
              @click="app_month = item"
              v-for="(item, index) in 12"
            >
              {{ item }}月
            </li>
          </ol>
        </div>
        <div @click="apptypeListShow = !apptypeListShow" class="expand">
          <div class="apptype-name">{{ curApptype }}</div>
          <div class="arrow"></div>
          <ul class="apptype-list" v-show="apptypeListShow">
            <li
              :key="index"
              @click="curApptype = item"
              v-for="(item, index) in apptypeList"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <div class="lvyou-app-rank single-line">
        <div class="chart-title">旅游APP使用排名</div>
        <div class="chart-content">
          <RankBar :chartData="appRankList" :lineNum="10" id="lvyouAppRank" />
        </div>
      </div>
      <div class="lvyou-app-qushi single-line">
        <div class="chart-title">旅游APPtop10使用变化趋势图</div>
        <div class="chart-content">
          <StackBar id="rijunkeliu" :chartData="appQushiData" />
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import RankBar from "@/components/Mycharts/RankBar.vue";
import StackBar from "@/components/Echarts/StackBar.vue";

export default {
  name: "XianshangXingweiFenxiDetail",
  components: {
    ChildModal,
    RankBar,
    StackBar
  },
  props: {},
  data() {
    return {
      app_month: 7,
      apptypeListShow: false,
      curApptype: "全部",
      apptypeList: [
        "全部",
        "旅游出行",
        "购物",
        "新闻资讯",
        "社交",
        "生活服务",
        "图片摄影"
      ],
      appRankList: [],
      appQushiData: null
    };
  },
  mounted() {
    // 请求旅游App使用排名
    fetch("/data/Home/XianshangXingweiFenxiDetail/LvyouAppShiyongPaiming.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.appRankList = json.data;
      });
    // 请求旅游App使用变化趋势
    fetch(
      "/data/Home/XianshangXingweiFenxiDetail/LvyouAppShiyongBianhuaQushi.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.appQushiData = json.data;
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
.child-detail {
  .mouth-and-type {
    margin-bottom: 0;
    min-height: 0;
    position: relative;
    z-index: 999;
    .chart-content {
      width: 80%;
      ol {
        width: 100%;
        li {
          width: 8.33%;
        }
      }
    }
    .expand {
      width: 1rem;
      height: 0.3rem;
      position: absolute;
      left: 1.1rem;
      top: 0.1rem;
      cursor: pointer;
      > div {
        float: left;
        height: 0.3rem;
        line-height: 0.3rem;
      }
      .arrow {
        width: 0.3rem;
        background: url(../../assets/header_menu/arrow.png);
        background-size: 100% 100%;
      }
      .apptype-list {
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 100%;
        background: #052148;
        border: 1px solid #00cdff;
        padding: 0.05rem 0;
        box-sizing: border-box;
        li:hover {
          background: #0c3964;
        }
      }
    }
  }
  .lvyou-app-rank {
    .chart-content {
      width: 80%;
    }
  }
  .lvyou-app-qushi {
    .chart-content {
      width: 86%;
    }
  }
}
</style>
